import { childrensTree, addQuotes } from '../utils/smartutils';
import { INDIVIDUAL } from '../utils/constants';

export function listIcons() {
  const query = `{listIcons {id, link}}`;
  return query;
}

export function maxNivelItemForNivel1(father) {
  const query = `{maxNivelItemForNivel1(father:${father})}`;
  return query;
}

export function mealTypes() {
  const query = `{mealTypes{id, name}}`;
  return query;
}

export function profileList() {
  const query = `{profileList(filter:{}){id, name}}`;
  return query;
}

export function itensTabletListByNivel() {
  const query = `{
    itensTabletListByNivel(level: 1, father: 0) {
      id
      name
      shortName
      description
      order
      active
      addOn
      sendTimeline
      level
      fatherCode
      program {
        id
      }
      typeOfMeal {
        id
        name
      }
      iconTablet {
        id
        link
      }
      iconTimeline {
        id
        link
      }
      multiple
      itemValue
      finalItem
      foodItem
      needsApproval
      approverProfile {
        id
        name
      }
      titleTimeline
      timelineTime
      requestTime
      requestTimeType
      calculatePeriod
      formItem
      notConform
    }
  }
  `;
  return query;
}

export function itemsTabletActiveListByLevelOnlyFormItems() {
  const query = `{
    itemsTabletActiveListByLevelOnlyFormItems(level: 1, father: 0, onlyFormItems: true) {
      id
      name      
    }
  }
  `;
  return query;
}

export function itensTabletByNivel1(father, maxNivel) {
  const template =
    'children{id, name, shortName, level, fatherCode, finalItem, iconTablet{id, link}, program{ id },';
  const children = childrensTree(maxNivel, template);
  const query = `{
    itensTabletByNivel1(father: ${father}) {
      id
      name
      shortName
      level
      finalItem
      iconTablet {
        id
        link
      }
      fatherCode,
      program{ id },
      ${children}
    }
  }
  `;
  return query;
}

export function itemTabletById(id) {
  const query = `{
    itemTabletById(id: ${id}) {
      id
      name
      shortName
      description
      order
      active
      addOn
      sendTimeline
      level
      fatherCode
      program {
        id
      }
      typeOfMeal {
        id
        name
      }
      iconTablet {
        id
        link
      }
      iconTimeline {
        id
        link
      }
      multiple
      itemValue
      finalItem
      foodItem
      needsApproval
      approverProfile {
        id
        name
      }
      titleTimeline
      timelineTime
      requestTime
      requestTimeType
      calculatePeriod
      formItem
      notConform
    }
  }
  `;
  return query;
}

export function saveTabletItemsMutation(values) {
  let typeOfMeal;
  let { foodItem } = values;
  if (foodItem) {
    if (values.typeOfMeal) {
      typeOfMeal = values.typeOfMeal.value;
    } else {
      foodItem = false;
      typeOfMeal = null;
    }
  } else {
    typeOfMeal = null;
  }

  let requestTimeType;
  let { requestTime } = values;
  if (requestTime) {
    if (values.requestTimeType) {
      requestTimeType = `"${values.requestTimeType.value}"`;
    } else {
      requestTime = false;
      requestTimeType = null;
    }
  } else {
    requestTimeType = null;
  }

  let approverProfile;
  let { needsApproval } = values;
  if (needsApproval) {
    if (values.approverProfile) {
      approverProfile = {
        ...values.approverProfile.value,
        accessToInternal: false,
        filterByStatus: false,
        updaterId: 0,
        accessToChat: false,
      };
    } else {
      needsApproval = false;
      approverProfile = null;
    }
  } else {
    approverProfile = null;
  }

  const mutationQuery = `mutation ($description: String!) { 
    saveItemTablet(
      itemTablet: {
        id:  ${values.id ? values.id : 0},
        name: "${values.name}",
        shortName: "${values.shortName}",
        description: $description,
        order: ${parseInt(values.order, 10)},
        active: ${values.active},
        addOn: ${values.addOn},
        sendTimeline: "${values.sendTimeline.value}",
        level: ${values.level},
        fatherCode: ${values.fatherCode},
        program: ${JSON.stringify(values.program).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )},
        typeOfMeal: ${JSON.stringify(typeOfMeal).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )},
        iconTablet: ${JSON.stringify(values.iconTablet).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )},
        iconTimeline: ${JSON.stringify(values.iconTimeline).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )},
        multiple:  ${
          values.multiple
            ? addQuotes(values.multiple.value)
            : addQuotes(INDIVIDUAL)
        },,
        itemValue:${values.itemValue ? values.itemValue : 0},
        finalItem: false,
        foodItem: ${foodItem},
        needsApproval: ${needsApproval},
        approverProfile: ${JSON.stringify(approverProfile).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )},
        titleTimeline: "${values.titleTimeline}",
        timelineTime: ${values.timelineTime},
        requestTime: ${requestTime},
        requestTimeType: ${requestTimeType},
        calculatePeriod: ${values.calculatePeriod},
        formItem: ${values.formItem},
        notConform: ${values.notConform},
        highestLevelChild: 0,
      }
    ) {
      id
    }
  }
  `;

  return mutationQuery;
}
